import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { questionnairesQueryOptions } from "$/modules/questionnaire/lib/queries";
import { CreateOrEditQuestionnaireModal } from "$/modules/questionnaire/ui/create-or-edit-questionnaire-modal";
import { QuestionnaireCard } from "$/modules/questionnaire/ui/questionnaire-card";
import { ConstructionHeader } from "$/modules/shared/ui/construction-header";
import { ContentGrid } from "$/modules/shared/ui/content-grid";
import { NoEntriesContainer } from "$/modules/shared/ui/no-entries";

export const Route = createFileRoute(
	"/$locale/$userId/projects/$projectId/questionnaire/",
)({
	component: QuestionnairePage,
	loader: async ({ params, context: { queryClient } }) => {
		await queryClient.ensureQueryData({
			...questionnairesQueryOptions(params.userId, params.projectId),
			revalidateIfStale: true,
		});
	},
});

function QuestionnairePage() {
	const t = useTranslations("project.questionnaire");
	const { userId, projectId } = Route.useParams();
	const { data: allQuestionnaires } = useSuspenseQuery(
		questionnairesQueryOptions(userId, projectId),
	);

	return (
		<>
			<ConstructionHeader titleKey={"project.questionnaire.title"}>
				<CreateOrEditQuestionnaireModal />
			</ConstructionHeader>

			{allQuestionnaires.total === 0 ? (
				<NoEntriesContainer icon="file-question" text={t("noQuestionnaires")} />
			) : (
				<ContentGrid>
					{allQuestionnaires.rows.map((questionnaire) => (
						<QuestionnaireCard key={questionnaire.$id} {...questionnaire} />
					))}
				</ContentGrid>
			)}
		</>
	);
}
